"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawDecorations = exports.DrawRealBricks = exports.RenderFromScratch = void 0;
var color_1 = require("./lib/color");
var data_1 = require("./data");
var math_1 = require("./lib/math");
var house_1 = require("./lib/house");
var url_1 = require("./lib/url");
var FrameColor = "#544966";
var GlassColor = "#81cbeb";
var ShadowColor = "rgba(0,0,0,0.2)";
var RoofColor = "#544966";
var BaseColor = "#a3a3a3";
var BlueprintColor = "rgba(255,255,255,0.2)";
var BrickWidthPx = 20;
var RoofHeightPx = 20;
var BaseHeightPx = 10;
var RoofBaseEdgePx = 10; // how much roof/base stick outside house
var ShadowHeightPx = 5;
var brickCanvasElement = document.getElementById("brick-canvas");
var brickCanvas = brickCanvasElement.getContext("2d");
var decorationsCanvasElement = document.getElementById("decorations-canvas");
var decorationsCanvas = decorationsCanvasElement.getContext("2d");
var skyCanvasElement = document.getElementById("sky-canvas");
var skyCanvas = skyCanvasElement.getContext("2d");
var canvasContainer = document.querySelector("#canvas-container");
var BrickHeightPx = BrickWidthPx / 2;
var BlockWidthPx = BrickWidthPx * data_1.HouseData.bricksPerRow;
var BlockHeightPx = BrickHeightPx * data_1.HouseData.rowsPerBlock;
var initiallyFullyRenderedBricks = 0;
var RenderFromScratch = function () {
    // if (isSimulated) {
    //   return;
    // }
    brickCanvasElement.width = data_1.HouseData.xBlocks * data_1.HouseData.bricksPerRow * BrickWidthPx + RoofBaseEdgePx * 2;
    brickCanvasElement.height = data_1.HouseData.yBlocks * data_1.HouseData.rowsPerBlock * BrickHeightPx + RoofHeightPx + BaseHeightPx;
    brickCanvas.clearRect(0, 0, brickCanvasElement.width, brickCanvasElement.height);
    decorationsCanvasElement.width = brickCanvasElement.width;
    decorationsCanvasElement.height = brickCanvasElement.height;
    setTimeout(function () {
        // needs some delay before the flex layout adjusts
        skyCanvasElement.width = 500 + data_1.GameData.itemLevel.houseSize * 50;
        skyCanvasElement.height =
            (skyCanvasElement.parentElement.offsetHeight / skyCanvasElement.parentElement.offsetWidth) * skyCanvasElement.width;
        RenderClouds();
    }, 1);
    // canvas will have width between 30vw...80vw
    var minWidth = 20;
    var maxWidth = 80;
    var maxWidthAtBlocks = 20; // max width is reached at 20 blocks width
    var percentage = data_1.HouseData.xBlocks / maxWidthAtBlocks;
    if (percentage > 1)
        percentage = 1;
    var canvasWidth = minWidth + (maxWidth - minWidth) * percentage;
    canvasContainer.style.width = "".concat(canvasWidth, "%");
    brickCanvas.beginPath();
    brickCanvas.strokeStyle = "rgba(255, 255, 255, 0.65)";
    brickCanvas.lineWidth = 1;
    for (var i = 0; i < data_1.HouseData.totalBricks; i++) {
        DrawBrick(i, false);
    }
    brickCanvas.stroke();
    initiallyFullyRenderedBricks = 0;
    (0, exports.DrawRealBricks)();
    (0, exports.DrawDecorations)();
};
exports.RenderFromScratch = RenderFromScratch;
/** Call this after placing some bricks to draw the real bricks. */
var DrawRealBricks = function () {
    while (initiallyFullyRenderedBricks < data_1.GameData.placedBricks) {
        DrawBrick(initiallyFullyRenderedBricks, true);
        initiallyFullyRenderedBricks++;
    }
};
exports.DrawRealBricks = DrawRealBricks;
var DrawBrick = function (id, isReal) {
    var totalBricksPerRow = data_1.HouseData.xBlocks * data_1.HouseData.bricksPerRow;
    var decrement = id;
    var halfBrickRow = false;
    var row = 0;
    while (decrement >= totalBricksPerRow) {
        decrement -= totalBricksPerRow;
        if (!halfBrickRow)
            decrement--;
        halfBrickRow = !halfBrickRow;
        row++;
    }
    if (halfBrickRow)
        decrement++;
    var width = BrickWidthPx;
    if (halfBrickRow && (decrement == 0 || decrement == totalBricksPerRow))
        width /= 2;
    if (isReal) {
        brickCanvas.fillStyle = (0, color_1.darken)((0, math_1.IntRandomBetween)(-6, 6), data_1.HouseData.colorTheme.brickColor);
        brickCanvas.fillRect(RoofBaseEdgePx + decrement * BrickWidthPx - (halfBrickRow && decrement > 0 ? BrickWidthPx / 2 : 0), brickCanvasElement.height - row * BrickHeightPx - BrickHeightPx - BaseHeightPx, width, BrickHeightPx);
    }
    else {
        brickCanvas.rect(RoofBaseEdgePx + decrement * BrickWidthPx - (halfBrickRow && decrement > 0 ? BrickWidthPx / 2 : 0), brickCanvasElement.height - row * BrickHeightPx - BrickHeightPx - BaseHeightPx, width, BrickHeightPx);
    }
};
var DrawDecorations = function () {
    decorationsCanvas.clearRect(0, 0, decorationsCanvasElement.width, decorationsCanvasElement.height);
    var blueprint = data_1.GameData.placedBricks < data_1.HouseData.totalBricks && (0, url_1.getQueryString)("ignoreBlueprint") !== "true";
    var data = (0, house_1.BuildHouseDecorations)();
    data.woodPanel.forEach(function (w) { return DrawWoodPanel(w, blueprint); });
    DrawDoor(data.doorBlockX, blueprint);
    data.verticalWindows.forEach(function (w) { return DrawVerticalWindow(w, blueprint); });
    data.horizontalWindow.forEach(function (w) { return DrawHorizontalWindow(w, blueprint); });
    DrawRoof(blueprint);
    DrawBase();
};
exports.DrawDecorations = DrawDecorations;
var DrawDoor = function (doorBlockX, blueprint) {
    var frameSpacingHorizontal = 15;
    var frameSpacingVertical = 20;
    decorationsCanvas.fillStyle = blueprint ? BlueprintColor : FrameColor;
    decorationsCanvas.fillRect(RoofBaseEdgePx + doorBlockX * BlockWidthPx + BlockWidthPx * 0.2, RoofHeightPx + data_1.HouseData.yBlocks * BlockHeightPx - BlockHeightPx + BlockHeightPx * 0.2, BlockWidthPx - BlockWidthPx * 0.4, BlockHeightPx * 0.8);
    if (blueprint) {
        return;
    }
    decorationsCanvas.fillStyle = GlassColor;
    decorationsCanvas.fillRect(RoofBaseEdgePx + doorBlockX * BlockWidthPx + BlockWidthPx * 0.2 + frameSpacingVertical, RoofHeightPx + data_1.HouseData.yBlocks * BlockHeightPx - BlockHeightPx + BlockHeightPx * 0.2 + frameSpacingHorizontal, BlockWidthPx - BlockWidthPx * 0.4 - frameSpacingVertical * 2, BlockHeightPx * 0.8 - frameSpacingHorizontal * 2);
};
var DrawVerticalWindow = function (windowData, blueprint) {
    DrawWindow(RoofBaseEdgePx + windowData.blockX * BlockWidthPx + BlockWidthPx * 0.1, RoofHeightPx + windowData.blockY * BlockHeightPx + BlockHeightPx * 0.1, BlockWidthPx - BlockWidthPx * 0.2, windowData.length * BlockHeightPx - BlockWidthPx * 0.2, blueprint);
};
var DrawHorizontalWindow = function (windowData, blueprint) {
    DrawWindow(RoofBaseEdgePx + windowData.blockX * BlockWidthPx + BlockWidthPx * 0.1, RoofHeightPx + windowData.blockY * BlockHeightPx + BlockHeightPx * 0.1, windowData.length * BlockWidthPx - BlockWidthPx * 0.2, BlockHeightPx - BlockHeightPx * 0.2, blueprint);
};
var DrawWindow = function (x, y, width, height, blueprint) {
    var frameSpacingWindow = 3;
    decorationsCanvas.fillStyle = blueprint ? BlueprintColor : FrameColor;
    decorationsCanvas.fillRect(x, y, width, height);
    if (blueprint) {
        return;
    }
    decorationsCanvas.fillStyle = GlassColor;
    decorationsCanvas.fillRect(x + frameSpacingWindow, y + frameSpacingWindow, width - frameSpacingWindow * 2, height - frameSpacingWindow * 2);
    decorationsCanvas.fillStyle = ShadowColor;
    decorationsCanvas.fillRect(x, y + height, width, ShadowHeightPx);
};
var DrawRoof = function (blueprint) {
    decorationsCanvas.fillStyle = blueprint ? BlueprintColor : RoofColor;
    decorationsCanvas.fillRect(0, 0, decorationsCanvasElement.width, RoofHeightPx);
    if (blueprint) {
        return;
    }
    decorationsCanvas.fillStyle = ShadowColor;
    decorationsCanvas.fillRect(RoofBaseEdgePx, RoofHeightPx, decorationsCanvasElement.width - 2 * RoofBaseEdgePx, ShadowHeightPx);
};
var DrawBase = function () {
    decorationsCanvas.fillStyle = BaseColor;
    decorationsCanvas.fillRect(0, decorationsCanvasElement.height - BaseHeightPx, brickCanvasElement.width, BaseHeightPx);
};
var DrawWoodPanel = function (data, blueprint) {
    if (blueprint) {
        return;
    }
    var woodImage = document.querySelector("#wood-panel-image");
    for (var x = 0; x < data.width; x++) {
        for (var y = 0; y < data.height; y++) {
            decorationsCanvas.drawImage(woodImage, RoofBaseEdgePx + data.blockX * BlockWidthPx + x * BlockWidthPx, RoofHeightPx + data.blockY * BlockHeightPx + y * BlockHeightPx, BlockWidthPx, BlockHeightPx);
        }
    }
};
var RenderClouds = function () {
    var cloudImages = [document.querySelector("#cloud-1"), document.querySelector("#cloud-2")];
    var maxCloudWidth = 150;
    var maxCloudHeight = maxCloudWidth / 2;
    skyCanvas.clearRect(0, 0, skyCanvasElement.width, skyCanvasElement.height);
    for (var x = 0; x < skyCanvasElement.width - maxCloudWidth; x += maxCloudWidth + maxCloudWidth * 0.6) {
        for (var y = 0; y < skyCanvasElement.height - maxCloudHeight; y += maxCloudHeight + maxCloudHeight * 0.6) {
            if (Math.random() > 0.4)
                continue;
            var img = cloudImages[Math.floor(Math.random() * cloudImages.length)];
            var width = maxCloudWidth - Math.floor(Math.random() * (maxCloudWidth * 0.25));
            var height = width * (img.height / img.width);
            var deviationX = x + (0, math_1.IntRandomBetween)(-maxCloudWidth * 0.3, maxCloudWidth * 0.3);
            var deviationY = y + (0, math_1.IntRandomBetween)(-maxCloudHeight * 0.3, maxCloudHeight * 0.3);
            deviationX = (0, math_1.clamp)(deviationX, 0, skyCanvasElement.width - width);
            deviationY = (0, math_1.clamp)(deviationY, 0, skyCanvasElement.height - height);
            skyCanvas.drawImage(img, deviationX, deviationY, width, height);
        }
    }
    skyCanvas.globalCompositeOperation = "source-in";
    skyCanvas.fillStyle = (0, color_1.darken)(-7, data_1.HouseData.colorTheme.skyColor);
    skyCanvas.fillRect(0, 0, skyCanvasElement.width, skyCanvasElement.height);
};
